module.exports = __webpack_public_path__ + "img/20200407153138898.f5a9e68c.png";